import React from 'react';
import { HelpCircle, Keyboard, MousePointer2, Sparkles, MessageSquare } from 'lucide-react';

export const HelpView: React.FC = () => {
  return (
    <div className="p-6 md:p-10 max-w-4xl mx-auto h-full overflow-y-auto custom-scrollbar">
      <div className="mb-10 text-center">
        <div className="w-20 h-20 bg-pink-100 rounded-[32px] flex items-center justify-center text-[#ff5c5c] mx-auto mb-6 shadow-sm">
           <HelpCircle size={40} strokeWidth={2.5} />
        </div>
        <h1 className="text-4xl font-black text-gray-800 mb-2 tracking-tight">使用帮助</h1>
        <p className="text-gray-400 font-medium">快速了解如何更高效地使用 InfiniteNote</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Shortcuts */}
        <div className="bg-white rounded-[40px] p-8 shadow-[0_8px_30px_rgb(0,0,0,0.02)] border border-pink-50">
          <h3 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
            <Keyboard size={24} className="text-blue-500" />
            快捷键
          </h3>
          <ul className="space-y-4">
            <li className="flex justify-between items-center text-sm">
              <span className="text-gray-500">双击空白处</span>
              <kbd className="px-3 py-1 bg-gray-50 border rounded-lg font-mono text-gray-600">新建文本</kbd>
            </li>
            <li className="flex justify-between items-center text-sm">
              <span className="text-gray-500">Ctrl + V</span>
              <kbd className="px-3 py-1 bg-gray-50 border rounded-lg font-mono text-gray-600">粘贴图片/文件</kbd>
            </li>
            <li className="flex justify-between items-center text-sm">
              <span className="text-gray-500">Delete / Backspace</span>
              <kbd className="px-3 py-1 bg-gray-50 border rounded-lg font-mono text-gray-600">删除选中项目</kbd>
            </li>
            <li className="flex justify-between items-center text-sm">
              <span className="text-gray-500">Ctrl + Z</span>
              <kbd className="px-3 py-1 bg-gray-50 border rounded-lg font-mono text-gray-600">撤销修改</kbd>
            </li>
          </ul>
        </div>

        {/* Interaction */}
        <div className="bg-white rounded-[40px] p-8 shadow-[0_8px_30px_rgb(0,0,0,0.02)] border border-pink-50">
          <h3 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
            <MousePointer2 size={24} className="text-[#ff5c5c]" />
            画布交互
          </h3>
          <ul className="space-y-4">
            <li className="flex gap-4 text-sm">
              <div className="w-8 h-8 rounded-full bg-pink-50 text-[#ff5c5c] flex-shrink-0 flex items-center justify-center font-bold">1</div>
              <p className="text-gray-600 mt-1">鼠标右键点击图片可进行旋转、置底、置顶等高级操作。</p>
            </li>
            <li className="flex gap-4 text-sm">
              <div className="w-8 h-8 rounded-full bg-blue-50 text-blue-500 flex-shrink-0 flex items-center justify-center font-bold">2</div>
              <p className="text-gray-600 mt-1">按住鼠标中键或空白处拖拽可平移画布，滚动滚轮可缩放。</p>
            </li>
            <li className="flex gap-4 text-sm">
              <div className="w-8 h-8 rounded-full bg-green-50 text-green-500 flex-shrink-0 flex items-center justify-center font-bold">3</div>
              <p className="text-gray-600 mt-1">拖拽项目到边缘可自动扩大画布边界。</p>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-10 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-[40px] p-10 text-white relative overflow-hidden shadow-xl">
         <Sparkles className="absolute top-4 right-4 text-white/20" size={80} />
         <h2 className="text-2xl font-black mb-4">需要更多帮助？</h2>
         <p className="text-white/80 mb-8 max-w-lg font-medium">如果你遇到任何问题或有改进建议，欢迎反馈。</p>
         <button className="bg-white text-indigo-600 px-8 py-3 rounded-2xl font-black shadow-lg hover:bg-indigo-50 transition-all flex items-center gap-2">
           <MessageSquare size={20} />
           立即反馈
         </button>
      </div>
    </div>
  );
};
